import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import PrivateRoute from '../../config/private-route';
import LessonPage from '.';
import { fetchToken, selectAuthentication, setUserEmail } from '../../redux/authenticationSlice';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCourseList, selectCourseList, updateCourseName } from '../../redux/courseListSlice';
import { toast } from 'react-toastify';
import { Mixpanel } from '../../config/Mixpanel';
import Loader from '../../components/Loader';
import { fetchCourseModule, selectCourseModule } from '../../redux/courseModuleSlice';

const Authenticate = () => {

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const emailID = params.get('email');
    const target = params.get('target');
    const { course_slug } = useParams();
    const [welcomePageLoading, setWelcomePageLoading] = useState(true);


    

    const dispatch = useDispatch();
    const authenticatedUid = useSelector(selectAuthentication)?.uid;
    const courseList = useSelector(selectCourseList);
    const courseModule = useSelector(selectCourseModule);
    const courseModuleRef = useRef(courseModule)
    const courseListRef = useRef(courseList)

    const navigate = useNavigate();

    const quizRef = useRef(null);

    useEffect(() => {
        courseModuleRef.current = courseModule
    }, [courseModule])

    useEffect(() => {
        courseListRef.current = courseList
    }, [courseList])


    useEffect(() => {
        let isActive = true;

        const fetchData = async () => {
            setWelcomePageLoading(true)
            let uid = emailID ? undefined : authenticatedUid
            let courses = courseListRef.current?.courses || []

            if (emailID) {
                dispatch(setUserEmail(emailID))
                try {
                    const response = await dispatch(fetchToken({ email_id: emailID })).unwrap()
                    if (response?.access_token){
                        uid = response?.uid
                        Mixpanel.identify(emailID);
                    }
                }catch (err) {
                    console.log(err.message);
                }
            }

            try {
                if (uid) {
                    if (emailID || !courses.length) {
                        const courseResponse = await dispatch(fetchCourseList()).unwrap()
                        courses = courseResponse?.courses || []
                    }
                    const selectedCourse = courses.find(
                        (course) => course.course_id && course.course_name?.toLowerCase() === course_slug?.toLowerCase()
                    )
                    if (!selectedCourse) {
                        toast.error("Course not found or unavailable.")
                        navigate('/welcome', { replace: true })
                        return
                    }
                    dispatch(updateCourseName(selectedCourse))
                    const currentCourse = courseModuleRef.current
                    const courseIsMissing = !currentCourse?.course_data?.length
                    const courseDoesNotMatchRoute = currentCourse?.course_id !== selectedCourse.course_id
                    if (emailID || courseIsMissing || courseDoesNotMatchRoute) {
                        await dispatch(fetchCourseModule({ course_id: selectedCourse.course_id })).unwrap()
                    }
                }
            } catch (err) {
                console.log(err.message)
                toast.error("Something went wrong! Please try again later.")
            } finally {
                if (isActive) setWelcomePageLoading(false)
            }
        }

        fetchData()
        return () => {
            isActive = false
        }
    }, [dispatch, emailID, navigate, course_slug, authenticatedUid])


    useEffect(() => {
        setTimeout(() => {
            if(target === "goal" && quizRef.current){
                quizRef.current.scrollIntoView({ behavior: 'smooth' })
            }
        }, 4000)
    }, [target, quizRef])



if(welcomePageLoading){
    return <Loader/>
}
  return (
    <PrivateRoute>
        <LessonPage quizRef={quizRef}/>
    </PrivateRoute>
  )
}

export default Authenticate
